// types

type TermMeta = string;

type Enumable<T> = [T, ...T[]];

// article categories

export const articleCategoryMeta = {
  code: 'Code',
  leadership: 'Leadership',
  product: 'Product',
  business: 'Business',
  music: 'Music',
  writing: 'Writing',
  games: 'Games',
  life: 'Life',
} as const satisfies Record<string, TermMeta>;
export type ArticleCategory = keyof typeof articleCategoryMeta;
export const articleCategories = 
  Object.keys(articleCategoryMeta) as Enumable<ArticleCategory>;
export const articleCategoryOpts = 
  articleCategories.map((value) => {
    return {value, label: articleCategoryMeta[value]};
  });

// project categories

export const projectCategoryMeta = {
  startups: 'Startups',
  code: 'Code',
  books: 'Books',
  music: 'Music',
  games: 'Games',
} as const satisfies Record<string, TermMeta>;
export type ProjectCategory = keyof typeof projectCategoryMeta;
export const projectCategories = 
  Object.keys(projectCategoryMeta) as Enumable<ProjectCategory>;
export const projectCategoryOpts = 
  projectCategories.map((value) => {
    return {value, label: projectCategoryMeta[value]};
  });

